// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Sp-z","breadcrumbForward":"Tp-z","breadcrumbBack":"Up-z","selected":"Vp-z"};